import React, { Component } from "react";
import { Sidebar, Menu } from "react-pro-sidebar";
import Dropdown from "react-bootstrap/Dropdown";
import LOGO from "../assets/images/logo.png";
import { readStorageJSON, alert, project, GET } from "./CustomComponent.js";
import { stripJuristic } from "./text-sanitize.js";
import "../assets/css/bootstrap.css";

// เมนูฝั่งงานขาย แบ่งเป็นกลุ่มตามงานที่ทำจริง ไม่ใช่ตามตารางใน DB
//
// ★ perm = คีย์สิทธิ์ที่ต้องมีถึงจะเห็นเมนูนั้น
//   ไม่มีสิทธิ์แล้วยังเห็นเมนู = กดเข้าไปเจอ 403 เปล่า ๆ
//   เมนูที่ไม่ระบุ perm = ทุกคนที่เข้าถึงงานขายได้เห็น
const salesMenu = [
  {
    group: "ภาพรวม",
    items: [
      // Console เป็นทางกลับไปเลือกโครงการ ต้องอยู่บนสุดเสมอ
      { key: "sales-console", name: "Console", link: "/console?tab=sales", icon: "\uf005" },
      { key: "sales-dashboard", name: "แดชบอร์ด", link: "/sale-dashboard", icon: "\uf080", perm: "sale-listing.read" },
    ],
  },
  {
    group: "จัดการทรัพย์",
    items: [
      // หน้าแก้ไขทรัพย์ (/project-room-edit) ส่ง menuKey เดียวกันมา เมนูนี้จึงไฮไลต์ค้าง
      // (หน้า "ข้อมูลทรัพย์ / การขาย" /project-room-sales ถูกลบแล้ว)
      { key: "sales-room-all", name: "จัดการทรัพย์", link: "/project-room-all", icon: "\uf00b", perm: "sale-listing.read" },
    ],
  },
  {
    group: "ลูกค้า",
    items: [
      { key: "sales-appointment", name: "นัดหมาย", link: "/sale-inquiries", icon: "\uf073", perm: "sale-inquiries.read" },
      // ประวัติ flow ขาย — อ่านอย่างเดียว ไม่มีสิทธิ์แก้/ลบให้ติ๊ก
      { key: "sales-listing-logs", name: "ประวัติการขาย", link: "/sale-listing-logs", icon: "\uf1da", perm: "sale-listing-logs.read" },
    ],
  },
  {
    group: "ตั้งค่า",
    items: [
      // ตั้งค่าของ "โครงการที่เปิดอยู่" — เข้าได้หลังเลือกโครงการเท่านั้น
      // (ไม่อยู่ในเมนู admin หลัก เพราะค่าทั้งหมดผูกกับโครงการ)
      {
        key: "sales-project-settings",
        name: "การตั้งค่าการขาย (โครงการ)",
        link: "/sale-project-settings",
        icon: "\uf013",
        perm: "sale-project-settings.read",
      },
      // ★ "เนื้อหาหน้าเว็บขาย" เป็นตั้งค่ากลางทั้งเว็บ — อยู่ในเมนูผู้ดูแลระบบ (global.menu) ไม่อยู่ในเมนูฝั่งโครงการ
    ],
  },
];

export default class SalesNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebar: false,
            profiles: null,
        };
    }

    async componentDidMount() {
        this.GetProfile();
    }

    async componentDidUpdate() {
        this.permissionSetting();
    }

    // ★ merge ทับของเดิม — /user/profile ไม่ได้คืน user_type ของลูกบ้าน
    //   เขียนทับทั้งก้อนแล้ว PropertyNavbar จะแยกไม่ออกว่าเป็นลูกบ้านหรือฝ่ายขาย
    mergeProfile = (data) => {
        const cached = readStorageJSON("cds-profile");
        const merged = { ...(cached || {}), ...data, password: "" };
        localStorage.setItem("cds-profile", JSON.stringify(merged));
        return merged;
    };

    GetProfile = async () => {
        const result = await GET("api/admin/user/profile");
        if (result?.status) {
            const merged = this.mergeProfile(result.data);
            this.setState({ profiles: merged });
            this.permissionSetting();
        }
    };
  
    permissionSetting = () => {
        // ยังไม่ได้โปรไฟล์ = ยังไม่ต้องลบอะไร (เดิมอ่าน state ผิดชื่อ เลยลบทิ้งหมดทุกคน)
        if (!this.state.profiles) return;
        const role = new Set(this.state.profiles?.role?.permissions || []);
        global.permission.forEach((perm) => {
            if (!role.has(perm)) {
                [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
            }
        });
    };

    // สิทธิ์ของผู้ใช้ที่ล็อกอินอยู่ — โปรไฟล์ยังไม่มาก็ยังไม่ต้องซ่อนอะไร
    // (กันเมนูกะพริบหายตอนโหลดหน้าแรก)
    hasPerm = (perm) => {
        if (!perm) return true;
        const profiles = this.state.profiles;
        if (!profiles) return true;
        return (profiles?.role?.permissions || []).includes(perm);
    };

    renderMenu = () => {
        const activeKey = this.props.menuKey;

        return (
            <div>
                {salesMenu.map((section) => {
                    const items = section.items.filter((item) => this.hasPerm(item.perm));
                    // กลุ่มที่ไม่เหลือเมนูเลย ไม่ต้องโชว์หัวข้อกลุ่มค้างไว้
                    if (!items.length) return null;

                    return (
                        <div key={section.group}>
                            <div className="my-2 text-12 text-secondary">
                                <b>{section.group}</b>
                            </div>
                            {items.map((item) => (
                                <a
                                    key={item.key}
                                    href={item.link}
                                    className={`btn btn-outline-dark border-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-1 rounded-3 ${activeKey === item.key ? "active" : ""}`}
                                    style={{ borderRadius: 12 }}
                                >
                                    <span className="icon wpx-20 ms-1" style={{ borderRadius: 10 }}>
                                        {item.icon}
                                    </span>
                                    <div className="mx-2">{item.name}</div>
                                </a>
                            ))}
                        </div>
                    );
                })}
                <hr />
            </div>
        );
    };

    render() {
        const { profiles } = this.state;
        return (
            <div>
                <Sidebar
                    className="position-fixed bg-white"
                    backgroundColor={"#ffffff"}
                    style={{
                        zIndex: 1000,
                        width: "250px",
                        height: "100vh",
                        overflow: "hidden",
                    }}
                    breakPoint="lg"
                    toggled={this.state.sidebar}
                    onFocus={() => {
                        this.setState({ sidebar: true });
                    }}
                >
                    <Menu
                        className="d-flex flex-column"
                        style={{
                            height: "100%",
                            overflowY: "auto",
                            paddingBottom: "60px",
                        }}
                    >
                        <div className="w-100 px-3 d-flex align-items-start justify-content-between my-2">
                            <img src={LOGO} height={42} alt="LOGO" className="mx-auto" />
                            <span
                                className="icon text-24 pointer d-block d-lg-none d-xl-none"
                                onClick={() => {
                                    this.setState({ sidebar: false });
                                }}
                            >
                                {"\uf00d"}
                            </span>
                        </div>
                        <div className="w-100 text-center">
                            <small>v.{process.env.REACT_APP_VERSION}</small>
                            <br />
                            <small className="text-8">©copy right by c.d.s. service .co.,ltd and OMS service</small>
                        </div>
                        <div className="px-3">{this.renderMenu()}</div>
                    </Menu>
                </Sidebar>

                <div className="body d-flex align-items-center justify-content-between mb-1 px-3 py-2">
                    <div className="d-flex align-items-center">
                        <label
                            className="me-3 d-block d-lg-none d-xl-none pointer"
                            onClick={() => {
                                this.setState({ sidebar: !this.state.sidebar });
                            }}
                        >
                            <span className="icon text-24">{"\uf0c9"}</span>
                        </label>
                        <div className="d-none d-sm-flex">
                            {this.props.page1 && <label className={this.props.page2 ? "text-secondary" : "text-success"}>{this.props.page1}</label>}
                            {this.props.page2 && <label className="text-secondary mx-2">{">"}</label>}
                            {this.props.page2 && <label className="text-success">{this.props.page2}</label>}
                        </div>
                    </div>

                    <div className="d-flex align-items-center bg-white py-1 px-1" style={{ borderRadius: 26 }}>
                        <div className="bg-success-light text-success wpx-40 hpx-40 d-flex justify-content-center align-items-center rounded-circle me-3">
                            {profiles?.full_name?.slice(0, 2).toUpperCase() || "US"}
                        </div>
                        <div className="me-3">
                            <div className="fw-bold">{profiles?.full_name || "-"}</div>
                            <small className="me-2">{stripJuristic(project?.project_name) || "ผู้ดูแลระบบ"}</small>
                        </div>
                        <Dropdown>
                            <Dropdown.Toggle variant="gray" id="dropdown-basic" size="sm">
                                <span className="icon pointer text-24 me-2">{"\uf107"}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                <Dropdown.Item
                                    className="rounded-3 d-flex align-items-center px-2"
                                    onClick={async () => {
                                        if (await alert("", "warning", "ออกจากระบบ", "ยืนยันการออกจากระบบหรือไม่?", "ออกจากระบบ", "ยกเลิก")) {
                                            localStorage.clear();
                                            window.location.href = "/";
                                        }
                                    }}
                                >
                                    <div className="fw-bold icon me-1 wpx-15 text-center text-12">{"\uf2f5"}</div> ออกจากระบบ
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        );
    }
}
